module.exports = __webpack_public_path__ + "img/icehockey-dark.91be8936.svg";